class t{constructor(t){this.displayName=t}static of(...s){return new t(new Map(s))}}export{t as ItemName};
